import { render, staticRenderFns } from "./AddMore.vue?vue&type=template&id=f08b8e58&scoped=true&"
import script from "./AddMore.vue?vue&type=script&lang=js&"
export * from "./AddMore.vue?vue&type=script&lang=js&"
import style0 from "./AddMore.vue?vue&type=style&index=0&id=f08b8e58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08b8e58",
  null
  
)

export default component.exports